'use strict'

import {mainForm} from "../scripts/components/Form.js"

const partnerForm = document.querySelector('form.partner-form')
if (partnerForm) new mainForm(partnerForm)
